<template>
    <!--
        The guest's page: no sidebar and no sign-in — one centred column, mobile first. It
        paints nothing itself; the theme's canvas on `body` is the background, the same as the
        house shell, so the page is recognisably the same product family.
    -->
    <div class="flex min-h-dvh flex-col">
        <header class="h-(--ui-header-height) shrink-0 border-b border-default bg-(--ui-bg-chrome)">
            <div class="mx-auto flex h-full w-full max-w-3xl items-center justify-between gap-3 px-4">
                <RouterLink :to="homeLink" class="flex min-w-0 items-center gap-2.5">
                    <img
                        v-if="appStore.tenant?.logo_image_id"
                        :src="publicImageUrl(appStore.tenant.slug, appStore.tenant.logo_image_id)"
                        alt=""
                        class="h-8 max-w-24 object-contain"
                    >
                    <img v-else src="/logo.svg" alt="" class="size-6">
                    <span class="truncate font-semibold text-highlighted">{{ appStore.tenant?.name || $t('brand.product_name') }}</span>
                </RouterLink>

                <div class="flex shrink-0 items-center gap-1">
                    <UButton
                        color="neutral"
                        variant="ghost"
                        size="sm"
                        icon="i-lucide-languages"
                        :label="appStore.locale === 'sl' ? 'EN' : 'SL'"
                        :aria-label="$t('layout.switch_language')"
                        @click="appStore.changeLocale(appStore.locale === 'sl' ? 'en' : 'sl')"
                    />
                    <ColorModeToggle />
                </div>
            </div>
        </header>

        <main class="mx-auto flex w-full max-w-3xl flex-1 flex-col gap-4 px-3 py-4 sm:px-4 sm:py-6 [&>*]:shrink-0">
            <router-view />
        </main>

        <footer class="px-4 py-6 text-center text-xs text-dimmed">{{ $t('layout.footer') }}</footer>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'

    import ColorModeToggle from '@/layouts/components/ColorModeToggle.vue'
    import { useAppStore } from '@/stores/app'
    import { publicImageUrl } from '@/types/Public'

    const route    = useRoute()
    const appStore = useAppStore()

    const homeLink = computed(() => route.params.slug ? { name: 'landing', params: { slug: route.params.slug } } : '/')
</script>
